<template>
  <div class="baseinfo-content">
    <Form ref="baseInfo" :label-width="110" inline>
      <Row type="flex" justify="center">
        <Col span="7">
          <FormItem label="班级ID：">
            {{ baseInfo.classroomId }}
          </FormItem>
        </Col>
        <Col span="7">
          <FormItem label="课程类别：">
            {{ classTypeList[baseInfo.classType] }}
          </FormItem>
        </Col>
        <Col span="7">
          <FormItem label="课程分类：">
            {{ baseInfo.courseTypeName }}
          </FormItem>
        </Col>
      </Row>
      <Row type="flex" justify="center">
        <Col span="7">
          <FormItem label="商品ID：">
            {{ baseInfo.relClassroomId }}
          </FormItem>
        </Col>
        <Col span="7">
          <FormItem label="商品名称：">
            {{ baseInfo.relClassroomName }}
          </FormItem>
        </Col>
        <Col span="7">
          <FormItem label="总课时：">
            {{ baseInfo.classroomTotal }}
          </FormItem>
        </Col>
      </Row>
      <Row type="flex" justify="center">
        <Col span="7">
          <FormItem label="学期：">
            {{ baseInfo.termName }}
          </FormItem>
        </Col>
        <Col span="7">
          <FormItem label="开课日期：">
            {{ baseInfo.classDateBegin.substring(0, 10) }}
          </FormItem>
        </Col>
        <Col span="7">
          <FormItem label="上课场地：">
            {{ baseInfo.placeName }}
          </FormItem>
        </Col>
      </Row>
      <Row type="flex" justify="center">
        <Col span="7">
          <FormItem label="班级群二维码：">
            <div v-if="baseInfo.courseQrCode">
              <img
                class="code-img"
                :src="downloadUrl + '?fileId=' + baseInfo.courseQrCode"
                alt=""
                @click="handleShowImgList"
              />
              <div class="code-text">家长可通过扫描识别此二维码进群</div>
            </div>
          </FormItem>
        </Col>
        <Col span="7"></Col>
        <Col span="7"></Col>
      </Row>
    </Form>
    <ReviewPhoto ref="reviewPhoto" :img-list="imgList"></ReviewPhoto>
  </div>
</template>
<script>
import ReviewPhoto from '@c/ReviewPhoto.vue';
export default {
  components: {
    ReviewPhoto
  },
  props: {
    baseInfo: {
      type: Object,
      default: () => { }
    },
    downloadUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      classTypeList: [
        '-',
        '课程',
        '托管'
      ], // 课程类别,1-课程 2-托管
      imgList: []
    };
  },
  methods: {
    // 点击打开照片
    handleShowImgList() {
      this.imgList = [this.baseInfo.courseQrCode];
      this.$nextTick(() => {
        this.$refs.reviewPhoto.open();
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.baseinfo-content {
  padding-top: 24px;
}
.code-img {
  height: 100px;
}
.code-text {
  color: #999;
  margin-top: 8px;
}
</style>
